import {httpClient} from './http-client';
const API_HOST = localStorage.getItem('SIDV2_API_HOST') || process.env.VUE_APP_SIDV2_API_HOST;

export default class SIDV2Service {
    async detect(req) {
        return httpClient({
            url: `detect-solar-issues`,
            baseURL: API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers
        })
    }
    async approve(req) {
        return httpClient({
            url: `plant-design`,
            baseURL: req.baseULR || API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers
        })
    }
}
